let swiper = null;
const mediaQuery = window.matchMedia('(max-width: 767px)');
const hasSlider = document.querySelector('.js-articles-main__slider');

if (hasSlider) {
	Promise.all([
		import('swiper'),
		import(
			/* webpackExports: ["Navigation", "Pagination"] */
			'swiper/modules'
		),
	])
		.then(([{ default: Swiper }, { Navigation, Pagination }]) => {
			const initSliderOrDestroy = () => {
				if (mediaQuery.matches) {
					swiper = new Swiper('.js-articles-main__slider', {
						slidesPerView: 'auto',
						navigation: {
							prevEl: '.js-articles-main__slider-arrow-left',
							nextEl: '.js-articles-main__slider-arrow-right',
						},
						pagination: {
							el: '.js-articles-main__slider .swiper-pagination',
						},
						modules: [Navigation, Pagination],
					});
				} else {
					if (swiper) {
						swiper.destroy();
					}
				}
			};

			initSliderOrDestroy();

			mediaQuery.addEventListener('change', () => {
				initSliderOrDestroy();
			});
		})
		.catch((err) => console.error(err));
}
